import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Box from "../../../widgets/Box/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import BadgeIcon from "@mui/icons-material/Badge";
import tokenUtils from "../../../utils/tokenUtils";

import headerStyles from "../header.module.scss";
import boxStyles from "../../../widgets/Box/box.module.scss";

const DetailRow = ({ icon: Icon, label, value, mono = false }) => (
  <>
    <Box className={boxStyles.detailRow}>
      <Box className={boxStyles.detailRowIconBox}>
        <Icon className={boxStyles.detailRowIcon} />
      </Box>
      <Box>
        <Typography component="span" className={boxStyles.detailRowLabel}>
          {label}
        </Typography>
        <Typography
          component="span"
          className={`${boxStyles.detailRowValue} ${mono ? boxStyles.detailRowValueMono : ""}`}
        >
          {value || "—"}
        </Typography>
      </Box>
    </Box>
    <Divider />
  </>
);

const getInitials = (details) => {
  if (!details) return "A";
  return (
    `${details.FirstName?.[0] || ""}${details.LastName?.[0] || ""}`.toUpperCase() ||
    "A"
  );
};

const ProfileModal = ({ open, onClose }) => {
  const adminDetails = tokenUtils.getDecodedToken();
  const fullName = adminDetails
    ? `${adminDetails.FirstName || ""} ${adminDetails.LastName || ""}`.trim() ||
      "Admin"
    : "Admin";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      slotProps={{
        paper: {
          className: headerStyles.profileModalPaper,
        }
      }}
    >
      <Box className={boxStyles.profileModalBanner}>
        <IconButton
          onClick={onClose}
          size="small"
          className={headerStyles.profileModalCloseBtn}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        <Avatar className={headerStyles.profileModalAvatar}>
          {getInitials(adminDetails)}
        </Avatar>

        <Box>
          <Typography className={headerStyles.profileModalName}>
            {fullName}
          </Typography>
          <Typography className={headerStyles.profileModalRole}>
            Admin Profile
          </Typography>
        </Box>
      </Box>

      <DialogContent className={headerStyles.profileModalContent}>
        <Box className={boxStyles.profileModalRows}>
          <DetailRow
            icon={PersonIcon}
            label="FIRST NAME"
            value={adminDetails?.FirstName}
          />
          <DetailRow
            icon={PersonIcon}
            label="LAST NAME"
            value={adminDetails?.LastName}
          />
          <DetailRow
            icon={PhoneIcon}
            label="PHONE NUMBER"
            value={adminDetails?.uid}
          />
          <Box className={boxStyles.detailRow}>
            <Box className={boxStyles.detailRowIconBox}>
              <BadgeIcon className={boxStyles.detailRowIcon} />
            </Box>
            <Box>
              <Typography component="span" className={boxStyles.detailRowLabel}>
                USER ID
              </Typography>
              <Typography
                component="span"
                className={`${boxStyles.detailRowValue} ${boxStyles.detailRowValueMono}`}
              >
                {adminDetails?.uam_id || "-"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ProfileModal;
